interface rellaxDataset {
  speed?: string,
  percent?: string
}

interface rellaxTypes {
  selector: string,
  dataset: rellaxDataset,
  wrapper?: string
}

const rellaxConfiguration: rellaxTypes[] = [
  {
    selector: '.sb-c-header__bg2',
    dataset: {
      speed: "-5",
    }
  },
  {
    selector: '.sb-c-header__bg3',
    dataset: {
      speed: "5",
    }
  },
  {
    selector: '.sb-bg-circle-2',
    dataset: {
      speed: "-3",
      percent: ".5"
    }
  },
  {
    selector: '.sb-bg-circle-3',
    dataset: {
      speed: "-3",
    }
  },
  {
    selector: '.sb-bg-rect-1',
    dataset: {
      speed: "-2",
    }
  },
  {
    // selector: '.sb-c-content .sb-bg-circle-4',
    selector: '.sb-bg-circle-4',
    dataset: {
      speed: "-3",
    },
    // wrapper: '.sb-c-content'
  },
]

export {
  rellaxConfiguration
}
